/* eslint-disable */
import NProgress from "nprogress"; // Progress 進度條
import router from "./router";
import store from "./store";
import "nprogress/nprogress.css"; // Progress 進度條樣式
import { setToken, getToken } from "@/utils/auth"; // eslint-disable-next-line
import { getCookie, setCookie, removeCookie } from "./utils/auth";
import { mapState } from "vuex";
const Login = () => import("@/views/layout/LoginLayout.vue");

const loadView = (view) => {
  // 路由懒加载
  return (resolve) => require([`@/views/${view}.vue`], resolve);
};

router.beforeEach(async (to, from, next) => {
  const quickToken = to.query.t;
  if (quickToken) {
    setToken(quickToken);
  }

  const queryWenUsrid = to.query.wen_usrid;
  const queryWenStsid = to.query.wen_stsid;
  const isMobileDevice = to.query.isMobileDevice;
  const cookieWenUsrid = getCookie("wenUsrid");
  const cookieWenStsid = getCookie("wenStsid");
  const hasLoginQuery = queryWenUsrid && queryWenStsid;
  const hasLoginCookie = cookieWenUsrid && cookieWenStsid;
  if (hasLoginQuery) {
    if (!hasLoginCookie || queryWenUsrid != cookieWenUsrid || queryWenStsid != cookieWenStsid || !getToken()) {
      // 舊系統參數，執行登入，取得token
      const params = {
        account: queryWenUsrid,
        role: queryWenStsid,
        isMobileDevice: isMobileDevice,
        redirectPath: to.path,
      };

      await $api.user
        .Login(params)
        .then((res) => {
          const { token } = res;

          if (token !== null) {
            setToken(token);
            setCookie("wenUsrid", queryWenUsrid);
            setCookie("wenStsid", queryWenStsid);
            store.dispatch("userInfo/GET_USER_PROFILE");
          }
        })
        .catch(() => {});
    }
  }

  if (to.path != "/" && to.path != "/Login") {
    setCookie("path", to.path);
  }

  if (!getToken()) {
    if (to.matched.length === 0) {
      let a = {
        path: "/",
        name: "loginLayout",
        meta: {
          remark: "登入",
        },
        component: loadView("layout/LoginLayout"),
        children: [
          {
            path: "/Login",
            name: "login",
            meta: {
              remark: "登入",
            },
            component: loadView("Login"),
          },
        ],
      };

      router.addRoute(a);
      next({ ...{ name: "login", query: to.query }, replace: true });
    } else {
      next();
    }
  } else {
    NProgress.start();
    // if (store.state.userInfo.modules.length > 0) return
    if (to.matched.length === 0) {
      store.dispatch("userInfo/GET_USER_PROFILE").then(() => {
        store.dispatch("userInfo/GET_USER_MODULES").then((modules) => {
          const data = JSON.parse(JSON.stringify(modules));
          // TODO: 這邊之後會遞迴寫
          data.forEach((r) => {
            r.component = loadView(r.meta.code);
            if (r.children) {
              r.children.forEach((c) => {
                c.component = loadView(c.meta.code);
                if (c.children) {
                  c.children.forEach((g) => {
                    g.component = loadView(g.meta.code);
                    if (g.children) {
                      g.children.forEach((o) => {
                        o.component = loadView(o.meta.code);
                      });
                    }
                  });
                }
              });
            }

            // ---------- 嵌入頁面基本參數 ----------
            // http://localhost:8080/A/ZAG/WENAG310?wen_usrid=加密的身分證字號&wen_stsid=身分別&singlePage=true

            // ---------- 外部網頁也可以透過自訂路徑嵌入頁面 ----------
            // http://localhost:8080/ag310_02_ap?wen_usrid=加密的身分證字號&wen_stsid=身分別&singlePage=true

            // ---------- 自訂頁面路徑 Start ----------
            r.children.push({ name: "Home", path: "/", component: loadView("Home") });
            r.children.push({ name: "ResetPassword", path: "/resetPassword", component: loadView("ResetPassword") });
            r.children.push({ name: "MyFavorite", path: "/myfavorite", component: loadView("MyFavorite") });
            // r.children.push({name: 'ag310_02_ap',path: '/ag310_02_ap',component: loadView('S32/S32W4002/Views/layer2View')})
            r.children.push({ name: "ag102_o", path: "/ag102_o", component: loadView("S31/S31W4002/Views/index") });
            r.children.push({ name: "cg400", path: "/cg400", component: loadView("S30/S30W2002/Views/index") });
            r.children.push({ name: "cg410", path: "/cg410", component: loadView("S30/S30W2003/Views/index") });
            r.children.push({ name: "approval", path: "/approval", component: loadView("S99/S99W4001/Views/index") });
            r.children.push({ name: "ak302", path: "/ak302", component: loadView("S41/S41W4009/Views/index") });
            r.children.push({ name: "zpe400", path: "/zpe400", component: loadView("S18/S18W4001/Views/index") });
            r.children.push({ name: "wen824", path: "/wen824", component: loadView("S41/S41W4001/Views/index") }); //教師核假作業(新版) 展開勤缺
            r.children.push({ name: "wen812bq", path: "/wen812bq", component: loadView("S43/S43W2004/Views/index") }); //教導師輔導

            r.children.push({ name: "wenck222", path: "/wenck222", component: loadView("S41/S41W3001/Views/index") }); //*學生公假批次申請(指導老師
            r.children.push({ name: "wenbk230", path: "/wenbk230", component: loadView("S41/S41W9001/Views/index") }); //*教師核假作業(新版)
            r.children.push({ name: "wenck001", path: "/wenck001", component: loadView("S41/S41W2001/Views/index") }); //*學生網路請假作業
            r.children.push({ name: "wen9042", path: "/wen9042", component: loadView("S41/S419W4001/Views/index") }); //*歷年導師評量成績查詢 (導師整合用)
            
            r.children.push({ name: "wenzcp400", path: "/wenzcp400", component: loadView("S56/S56W2001/Views/index") }); //*汽車車位申請作業
            r.children.push({ name: "wenzcp402", path: "/wenzcp402", component: loadView("S56/S56W2002/Views/index") }); //*機車車位申請作業
            r.children.push({ name: "wenzgs49", path: "/wenzgs49", component: loadView("S49/S49W2001/Views/index") }); //*處理台企銀銀行自動銷帳作業
            r.children.push({ name: "zpc002", path: "/zpc002_pass_ap", component: loadView("S20/S20W9001/Components/ZPC002_app") }); // 會總簽核系統 PB 查詢
            r.children.push({ name: "zpc003", path: "/zpc003_pass_ap", component: loadView("S20/S20W9001/Components/ZPC003_app") }); // 會總簽核系統 PB 查詢
            r.children.push({ name: "zpe506", path: "/zpe506_pass_ap", component: loadView("S18/S18W9001/Components/ZPE506_app") }); // 專案人員薪資系統 PB 查詢
            r.children.push({ name: "wenag203", path: "/wenag203", component: loadView("S32/S32W1005/Views/index") }); //*教學綱要  查詢

            // ---------- 自訂頁面路徑 End ----------

            // ---------- admin 權限控制 ----------
            const untId = store.state.userInfo.userInfo.employeeInfo.untId;
            if (untId == "II20" || untId == "II00") {
              r.children.push({ name: "Admin", path: "/admin", component: loadView("Admin/Views/index") });
            }

            // ---------- 職員 權限控制 ----------
            const role = store.state.userInfo.userInfo.role;
            if (role == "01") {
              r.children.push({ name: "Fcm", path: "/fcm", component: loadView("WzuFcm/Views/index") });
            }

            // r.children.push({name: 'Promote',path: '/promote',component: loadView('Promote')})
            // -- 2022/6/2 這邊看要導回404 page還是首頁 --
            //r.children.push({name: 'PageNotFound',path: '/:pathMatch(.*)*',component: loadView('PageNotFound')})
            r.children.push({
              name: "PageNotFound",
              path: "/:pathMatch(.*)*",
              beforeEnter(to) {
                next({ ...{ name: "", query: to.query }, replace: true });
              },
            });
            router.addRoute(r);
          });

          if (hasLoginQuery) {
            next({ ...{ path: to.path, query: to.query }, replace: true }); // 將導頁query remove
          } else {
            const path = getCookie("path") ?? to.path;
            next({ ...{ path: path, query: to.query }, replace: true });
            // next({ ...to, replace: true }); // hack方法 確保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          }
        });
      });
    } else {
      //removeCookie("path");
      next();
    }
  }
  // next()
});

router.afterEach(() => {
  NProgress.done(); // 結束Progress
});
